var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"v2-retailer-dashboard"},[_c('v2-dashboard-welcome-card',{attrs:{"current-association":_vm.currentAssociation}}),_c('v2-dashboard-brands-list'),_c('v2-dashboard-wishlist'),_c('v2-dashboard-orders-list')],1)}
var staticRenderFns = []

export { render, staticRenderFns }